import { Pipe, PipeTransform, inject } from '@angular/core';

import { CodeValueGroups } from '../model';
import { CodeValueService } from '../services/code-value.service';

interface WorkerProfile {
  Id: number;
  ContactId: number;
  ProfileTypeId: number;
  Contact: {
    PreferredFirstName: string;
    PreferredLastName: string;
  };
}

@Pipe({
  name: 'workerProfileDisplay',
  standalone: false
})
export class WorkerProfileDisplayPipe implements PipeTransform {
  private readonly codeValueService = inject(CodeValueService);

  transform(worker: WorkerProfile | null): string {
    if (!worker) {
      return '';
    }

    const profileTypeName = this.codeValueService.getCodeValue(worker.ProfileTypeId, CodeValueGroups.ProfileType)?.text || '';
    return `${worker.Contact.PreferredFirstName} ${worker.Contact.PreferredLastName} - ${worker.ContactId} (${profileTypeName} - ${worker.Id})`;
  }
}
